var map = {
	"./auth/templates/js/setup.js": 38795,
	"./billing/templates/js/setup.js": 95888,
	"./coins/templates/js/setup.js": 72185,
	"./exchanges/templates/js/setup.js": 96786,
	"./heatmap/templates/js/setup.js": 95626,
	"./system/templates/js/setup.js": 87360,
	"./telegram/templates/js/setup.js": 52899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4157;